import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { List, Map } from 'immutable';

import DropDown, { DropDownElement } from '../helpers/DropDown';

/**
 * Stateless component for drop down on top page.
 *
 * @param props {Object}.
 * @param dropdownItems {Object} List of available actions.
 * @param onClick {Function} To handle item click event.
 */
const SearchDropDownComponent = ({ dropdownItems, hasAccess, onClick }) => {
  const items = dropdownItems.reduce((accumulator, element, index) => {
    if (!hasAccess && ['new_buyer', 'new_executive', 'new_lp'].includes(element.get('key'))) {
      return accumulator;
    }

    accumulator.push(
      <DropDownElement key={index} onClick={event => onClick({ event, to: element.get('to') })} value={element.get('key')}>
        {element.get('name')}
      </DropDownElement>,
    );

    return accumulator;
  }, []);

  return (
    <DropDown
      align="right"
      buttonContent={Map({ name: 'New', value: '' })}
      className="btn-default btn-xs"
      id="searchingDropDown"
    >
      {items}
    </DropDown>
  );
};

SearchDropDownComponent.propTypes = {
  dropdownItems: PropTypes.instanceOf(List).isRequired,
  onClick: PropTypes.func.isRequired,
};

export const SearchDropDown = memo(SearchDropDownComponent);
